module.exports = __webpack_public_path__ + "img/dankoff_loader.0fc31c6a.svg";